import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataFileDownload } from 'src/app/data/models/dto/data-file-download';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { FileService } from 'src/app/data/services/file.service';
import { RoomsMessagesService } from 'src/app/data/services/rooms-messages.service';
import { FileUtils } from 'src/app/data/utils/file.utils';

@Component({
  selector: 'app-chat-file-downloader',
  templateUrl: './chat-file-downloader.component.html',
  styleUrls: ['./chat-file-downloader.component.scss'],
})
export class ChatFileDownloaderComponent {
  @Input() file!: DataFileDownload | FileDto;

  @Output() onError = new EventEmitter<boolean>();

  processing = false;

  cancel = new Subject<boolean>();

  constructor(
    private readonly roomsMessagesService: RoomsMessagesService,
    private readonly fileUtils: FileUtils,
    private readonly fileService: FileService
  ) {}

  get isFileDto() {
    return typeof this.file === 'object' && 'bucketKey' in this.file;
  }

  async download(event: boolean) {
    if (!this.isFileDto) {
      await this.downloadByOldApi(event);
    } else {
      await this.downloadFile(event);
    }
    this.processing = false;
  }

  //TODO remove on next cicle
  private async downloadByOldApi(event: boolean) {
    try {
      let file = this.file as DataFileDownload;
      if (file.idMessage && event) {
        this.cancel.next(false);

        const response = await this.roomsMessagesService
          .downloadFileByIdRoom(file.entityName, file.idMessage, file.fileName)
          .pipe(takeUntil(this.cancel.asObservable()))
          .toPromise();

        if (!response) {
          return;
        }
        const arqFile = this.fileUtils.FromByteArrayToFile(
          response.data,
          file.fileName
        );

        if (arqFile) {
          saveAs(arqFile, file.fileName);
        }
      } else {
        this.cancel?.next(true);
      }
    } catch (error) {
      this.onError.emit(true);
    }
  }

  private async downloadFile(event: boolean) {
    try {
      let file = this.file as FileDto;
      if (file.id && event) {
        this.cancel.next(false);
        const arrayBuffer = await this.fileService
          .downloadByUrlPath(file.path)
          .pipe(takeUntil(this.cancel.asObservable()))
          .toPromise();
        const arqFile = this.fileUtils.FromByteArrayToFile(
          arrayBuffer,
          file.name
        );
        if (arqFile) {
          saveAs(arqFile, file.name);
        }
      } else {
        this.cancel?.next(true);
      }
    } catch (error) {
      this.onError.emit(true);
    }
  }
}
